import { createContext, useContext, useState } from "react";
import TransactionDialog from "@/components/TransactionDialog";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [version, setVersion] = useState(0);
  const [tx, setTx] = useState(null); // null | {choose:true} | {type, record}

  const refresh = () => setVersion((v) => v + 1);
  const openTransaction = (type = null, record = null) =>
    setTx(type ? { type, record } : { choose: true });
  const closeTransaction = () => setTx(null);

  return (
    <AppContext.Provider value={{ version, refresh, openTransaction }}>
      {children}
      <TransactionDialog
        state={tx}
        onClose={closeTransaction}
        onPick={(t) => setTx({ type: t })}
        onSaved={() => { refresh(); }}
      />
    </AppContext.Provider>
  );
}
